import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ReplyTypeForm from '../../../components/forms/ReplyTypeForm';
import { useReplyTypeApi } from '../../../hooks/useReplyTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ReplyTypeDTO } from '../../../services/apiClient';

const ReplyTypeEdit: React.FC = () => {
  const { getById, edit, isLoading } = useReplyTypeApi();
  const [entityData, setEntityData] = useState<ReplyTypeDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Reply Types', href: '/admin/replytypes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching ReplyType data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/replytypes');
    } catch (error) {
      console.error('Error updating ReplyType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/replytypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ReplyType.Edit'
    >
        {entityData ? (
          <ReplyTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/replytypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ReplyTypeEdit;